import { CheckCircle2 } from 'lucide-react';

/**
 * Landingsside for SEB "Quit URL" — vises når kandidaten klikker "Avslutt eksamen"
 * i SEB-browseren. Ingen data-lasting, ingen API-kall. SEB oppdager at denne
 * URL-en er nådd og avslutter automatisk sin kiosk-modus.
 */
export default function ExamQuit() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <div className="flex justify-center mb-4">
          <CheckCircle2 className="w-16 h-16 text-green-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-3">
          Eksamen er avsluttet
        </h1>
        <p className="text-gray-700 mb-4">
          Takk for at du gjennomførte prøven.
        </p>
        <div className="bg-kf-blue-50 border border-kf-blue-200 rounded p-4 text-sm text-kf-blue-900 text-left">
          <p className="font-medium mb-2">Videre:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Besvarelsen er registrert og du har fått kvittering på e-post og SMS (hvis du valgte det).</li>
            <li>Du kan trygt lukke dette vinduet.</li>
            <li>Etter sensur blir kompetanseattesten din tilgjengelig i kandidatportalen —
              du vil motta e-post og SMS med lenke når den er klar.</li>
          </ul>
        </div>
        <p className="mt-6 text-xs text-gray-500">
          Kompetanseattest — Kompetanseforbundet
        </p>
      </div>
    </div>
  );
}
